<template>
    <div class="cz2__panel cz2__panel--secondary cz2__panel--secondary-fullscreen cz2__product-help-child">
        <focus-lock :disabled="focusLockDisabled">
            <div class="cz2__panel__header cz2__panel__header--help">
                <div class="cz2__details-header">
                    <div class="cz2__type__header cz2__product-title">{{$t('MENU_HELP')}}</div>
                    <div class="cz2__type__normal cz2__type__no-wrap">
                        {{selectedStepParameters.topic.header}}
                    </div>
                </div>
            </div>

            <div class="cz2__panel__body cz2__panel__body--with-html">
                <div v-html="content" @click.prevent="toggle($event)"></div>
            </div>

            <div class="cz2__panel__actions">
                <button class="cz2__panel-action cz2__panel-action--cancel" @click.prevent="cancel"><span>{{$t('MENU_BACK')}}</span></button>
            </div>
        </focus-lock>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__product-help-child {
            .cz2__panel__header.cz2__panel__header--with-back-button {
                display: flex;
                align-items: center;

                .cz2__panel-header__back-button {
                    display: block;
                }

                .cz2__panel__back-button {
                    flex: 0 0 auto;

                    width: 44px;
                    height: 44px;

                    margin-right: 24px;

                    background: transparent url(../assets/back@2x.png) no-repeat center/contain;
                }

                .cz2__details-header {
                    flex: 1 0 auto;
                    width: 1px;
                }
            }

            section {
                position: relative;

                &.section--expanded {
                    p {
                        display: block;
                    }

                    ul {
                        display: block;
                    }

                    header {
                        &:after {
                            transform: rotate(90deg);
                        }
                    }
                }

                p {
                    display: none;
                }

                ul {
                    display: none;
                }

                header {
                    position: relative;

                    cursor: pointer;

                    &:after {
                        content: '';

                        display: block;

                        position: absolute;

                        right: 12px;
                        top: calc(50% - 6px);

                        width: 8px;
                        height: 13px;

                        background: transparent url(../assets/arrow-small-right@2x.png) no-repeat center/contain;

                        @include respond-above(sm) {
                            right: 20px;
                        }
                    }
                }
            }
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';

    export default {
        components: {
            FocusLock,
        },
        data() {
            return {
                focusLockDisabled: true,
            };
        },
        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            /**
             * Retrives panel content.
             */
            selectedStepParameters() {
                return this.$store.state.selectedStepParameters;
            },

            /**
             * Format product price levels.
             */
            priceLevels() {
                if (this.viewController == null) {
                    return [];
                }

                const { priceTiers } = this.$store.getters;

                return priceTiers.map((p, index) => {
                    const last = index === priceTiers.length - 1;

                    return this.$t('PRODUCT_INFO_PRICING_COPY_DETAILS', {
                        units: last ? `${p.quantity}+` : p.quantity,
                        save: p.formatted ?? p.amount,
                    });
                });
            },

            /**
             * Retrieves product short description.
             */
            shortDescription() {
                const v = this.viewController
                    && this.viewController.blueprint.custom['v-short-description'];

                return v && v.length > 0 ? v : null;
            },

            /**
             * Format content.
             */
            content() {
                let c = this.selectedStepParameters.topic.content;

                c = c.replace('PRODUCT_PLACEHOLDER', this.shortDescription);

                c = c.replace('PRICING_PLACEHOLDER', `<ul>${this.priceLevels.map((p) => `<li>${p}</li>`).join('')}</ul>`);

                return c;
            },
        },
        mounted() {
            // Otherwise this messes with transition animation because browsers will try to scroll to the focused item, which would be off-screen.
            this.$store.state.eventBus.$once('secondaryEntered', () => {
                // this.focusLockDisabled = false;
            });

            this.$el.addEventListener('click', this.aClick);
        },
        beforeDestroy() {
            this.$el.removeEventListener('click', this.aClick);
        },
        methods: {
            /**
             * Go back.
             */
            cancel() {
                // Go back to the main screen.
                this.$store.dispatch('selectStep', 'help');
            },

            aClick(e) {
                if (e.target && e.target.tagName === 'A') {
                    if (e.target.target === '_blank' && e.target.href && e.target.href.length > 0) {
                        window.open(e.target.href);
                    }
                }
            },

            /**
             * Toggle a section.
             */
            toggle(e) {
                if (e.target && e.target.tagName === 'HEADER') {
                    const $section = e.target.closest('section');

                    if ($section) {
                        const expanded = $section.classList.contains('section--expanded');

                        if (expanded) {
                            $section.classList.remove('section--expanded');
                        } else {
                            $section.classList.add('section--expanded');
                        }
                    }
                }
            },
        },
    };
</script>
